import React from 'react'

import DetailMapPublic from '~/modules/_components/Assets/DetailMapPublic'

const DetailMapPublicPage = () => <DetailMapPublic />

export default DetailMapPublicPage
